export const dosageFormMap: Record<string, string> = {
  AEPB: 'Aerosol Powder Breath Activated',
  AERB: 'Aerosol Breath Activated',
  AERO: 'Aerosol',
  AERP: 'Aerosol Powder',
  AERS: 'Aerosol Solution',
  AJKT: 'Auto-injector Kit',
  AUIJ: 'Auto-injector',
  BAR: 'Bar',
  BEAD: 'Beads',
  C12A: 'Capsule ER 12 Hour Abuse-Deterrent',
  C24A: 'Capsule ER 24 Hour Abuse-Deterrent',
  C2PK: 'Capsule ER 12 Hour Therapy Pack',
  C4PK: 'Capsule ER 24 Hour Therapy Pack',
  CAPA: 'Capsule Abuse-Deterrent',
  CAPS: 'Capsule',
  CART: 'Cartridge',
  CDPK: 'Capsule Delayed Release Therapy Pack',
  CEPK: 'Capsule Extended Release Therapy Pack',
  CHER: 'Tablet Chewable Extended Release',
  CHEW: 'Tablet Chewable',
  CONC: 'Concentrate',
  CP12: 'Capsule Extended Release 12 Hour',
  CP24: 'Capsule Extended Release 24 Hour',
  CPCR: 'Capsule Extended Release',
  CPCW: 'Capsule Chewable',
  CPDR: 'Capsule Delayed Release',
  CPEA: 'Capsule Extended Release Abuse-Deterrent',
  CPEC: 'EC Cap (Obsolete)',
  CPEP: 'Capsule Delayed Release Particles',
  CPPK: 'Capsule Therapy Pack',
  CPSP: 'Capsule Sprinkle',
  CREA: 'Cream',
  CRYS: 'Crystals',
  CS12: 'Capsule ER 12 Hour Sprinkle',
  CS24: 'Capsule ER 24 Hour Sprinkle',
  CSDR: 'Capsule Delayed Release Sprinkle',
  CSER: 'Capsule Extended Release Sprinkle',
  CTKT: 'Cartridge Kit',
  DCHE: 'Douche (Obsolete)',
  DCHP: 'Douche Pow (Obsolete)',
  DCHS: 'Douche Sol (Obsolete)',
  DEVI: 'Device',
  DISK: 'Disk',
  DPRH: 'Diaphragm',
  ELIX: 'Elixir',
  EMUL: 'Emulsion',
  ENEM: 'Enema',
  EXHA: 'Exhaler',
  EXHL: 'Exhaler Liquid',
  EXHP: 'Exhaler Powder',
  EXHS: 'Exhaler Solution',
  EXHU: 'Exhaler Suspension',
  EXTR: 'Fluid Extract',
  FILM: 'Film',
  FLAK: 'Flakes',
  FOAM: 'Foam',
  GAS: 'Gas',
  GEL: 'Gel',
  GRAN: 'Granules',
  GREF: 'Granules Effervescent',
  GUM: 'Gum',
  IMPL: 'Implant',
  INHA: 'Inhaler',
  INJ: 'Injectable',
  INST: 'Insert',
  IUD: 'Intrauterine Device',
  JTAJ: 'Jet-injector',
  JTKT: 'Jet-injector Kit (Needleless)',
  KIT: 'Kit',
  LEAV: 'Leaves',
  LIQD: 'Liquid',
  LOTN: 'Lotion',
  LOZG: 'Lozenge',
  LPOP: 'Lozenge on a Handle',
  LQCR: 'Liquid Extended Release',
  LQPK: 'Liquid Therapy Pack',
  MISC: 'Miscellaneous',
  NEBU: 'Nebulization Solution',
  OCSY: 'Ocular System (Obsolete)',
  OIL: 'Oil',
  OINT: 'Ointment',
  PACK: 'Packet',
  PADS: 'Pad',
  PDEF: 'Powder Effervescent',
  PEN: 'Pen-injector',
  PLLT: 'Pellet',
  PNKT: 'Pen-injector Kit',
  POWD: 'Powder',
  PRSY: 'Prefilled Syringe',
  PSKT: 'Prefilled Syringe Kit',
  PSTE: 'Paste',
  PT24: 'Patch 24 Hour',
  PT72: 'Patch 72 Hour',
  PTCH: 'Patch',
  PTTW: 'Patch Twice Weekly',
  PTWK: 'Patch Weekly',
  PUDG: 'Pudding',
  RING: 'Ring',
  SHAM: 'Shampoo',
  SHEE: 'Sheet',
  SOAJ: 'Solution Auto-injector',
  SOCT: 'Solution Cartridge',
  SOLG: 'Gel Forming Solution',
  SOLN: 'Solution',
  SOLR: 'Solution Reconstituted',
  SOPK: 'Solution Therapy Pack',
  SOPN: 'Solution Pen-injector',
  SOSY: 'Solution Prefilled Syringe',
  SOTJ: 'Solution Jet-injector',
  SPRT: 'Spirit',
  SRER: 'Suspension Reconstituted ER',
  STCK: 'Stick',
  STRP: 'Strip',
  SUAJ: 'Suspension Auto-injector',
  SUBL: 'Tablet Sublingual',
  SUCT: 'Suspension Cartridge',
  SUER: 'Suspension Extended Release',
  SUPK: 'Suspension Therapy Pack',
  SUPN: 'Suspension Pen-injector',
  SUPP: 'Suppository',
  SUSP: 'Suspension',
  SUSR: 'Suspension Reconstituted',
  SUSY: 'Suspension Prefilled Syringe',
  SUTJ: 'Suspension Jet-injector',
  SWAB: 'Swab',
  SYRP: 'Syrup',
  T12A: 'Tablet ER 12 Hour Abuse-Deterrent',
  T24A: 'Tablet ER 24 Hour Abuse-Deterrent',
  T2PK: 'Tablet ER 12 Hour Therapy Pack',
  T4PK: 'Tablet ER 24 Hour Therapy Pack',
  TABA: 'Tablet Abuse-Deterrent',
  TABS: 'Tablet',
  TAMP: 'Tampon',
  TAPE: 'Tape',
  TAR: 'Tar',
  TB12: 'Tablet Extended Release 12 Hour',
  TB24: 'Tablet Extended Release 24 Hour',
  TB3D: 'Tablet Disintegrating Soluble',
  TB3E: 'Tablet Disintegrating Soluble ER',
  TBCR: 'Tablet Extended Release',
  TBDD: 'Tablet Delayed Release Disintegrating',
  TBDP: 'Tablet Disintegrating',
  TBDR: 'Tablet Delayed Release (Obsolete)',
  TBEA: 'Tablet Extended Release Abuse-Deterrent',
  TBEC: 'Tablet Delayed Release',
  TBED: 'Tablet Extended Release Disintegrating',
  TBEF: 'Tablet Effervescent',
  TBPK: 'Tablet Therapy Pack',
  TBSO: 'Tablet Soluble',
  TDPK: 'Tablet Delayed Release Therapy Pack',
  TEPK: 'Tablet Extended Release Therapy Pack',
  TEST: 'Diagnostic Test',
  THPK: 'Therapy Pack',
  TINC: 'Tincture',
  TPPK: 'Tablet Disintegrating Therapy Pack',
  TROC: 'Troche',
  WAFR: 'Wafer',
  WAX: 'Wax',
  WHIP: 'Whip (Obsolete)',
};

export type CreateValues = Omit<StandardMedication, 'id'>;

export interface StandardMedication {
  id: string;
  displayName: string;
  name: string;
  administrationRoute?: string;
  dosageForm?: string;
  strength?: string;
  strengthUnit?: string;
}
